import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { showCart } from "../ReduxToolKit/cartSlice"

const EmptyCart = () => {
    const dispatch = useDispatch()
    return (
        <>
            <div className="flex items-center w-full gap-3 flex-col absolute top-[50%] translate-y-[-50%]">
                <img className=" w-[200px]" src="../images/emptybag.png" />
                <button className="bg-black py-2 rounded-md cursor-pointer w-[200px] md:w-[250px] text-white">
                    <Link to="/ " onClick={() =>dispatch(showCart(false))}>
                        Go Back to Nike store
                    </Link>
                </button>
            </div>
        </>
    )
}
export default EmptyCart